<template lang="html">
  <div class="edit-site-analytics tier tier-three">
    <Tooltip
      content="Connect your Google Analytics account to track website visitors"
    />

    <Notification
      v-if="notification.active"
      :content="notification.content"
      :type="notification.type"/>

    <div class="tier-content">
      <Tabs ref="analyticTabs" :headings="['Your Analytics ID', 'Connect Account']">
        <Tab>
          <div>
            <SiteAnalyticsForm
              @submit="submitSite"
              v-model="site"
              :errors="errors"
            />
          </div>
        </Tab>

        <Tab>
          <div>
            <p>
              Google Analytics is an essential tool to help you understand where
              your customers are coming from. With Google Analytics you will be
              able to better understand your visitors, their behaviour, and
              their preferences.
            </p>

            <hr />

            <h3>How to connect</h3>

            <div class="helper-text">
              <p>
                Do you already have a
                <a href="https://myaccount.google.com/intro" target="_blank"
                  >Google account</a
                >?
              </p>

              <div class="guide-options">
                <Btn secondary @click="activateGoogleControls">Yes</Btn>
                <router-link
                  class="btn is-secondary"
                  :to="{name: 'analytics-create-google-account'}"
                  >No</router-link
                >
              </div>
            </div>

            <div class="helper-text" v-if="hasGoogleAccount">
              <p>
                Do you have a
                <a
                  href="https://analytics.google.com/analytics/web/"
                  target="_blank"
                  >Google Analytics</a
                >
                account?
              </p>

              <div class="guide-options">
                <router-link
                  class="btn is-secondary"
                  :to="{name: 'analytics-admin'}"
                  >Yes</router-link
                >
                <router-link
                  class="btn is-secondary"
                  :to="{name: 'analytics-create-analytics-account'}"
                  >No</router-link
                >
              </div>
            </div>

            <hr />

            <p>Need a hand? Feel free to contact us.</p>
          </div>
        </Tab>
      </Tabs>

      <router-view />
    </div>
  </div>
</template>

<script>
import page from '@/mixins/page'
import notification from '@/mixins/notification'

import {updateCompanySiteData, readCompanySiteData} from '@/lib/sites'

import SiteAnalyticsForm from '@/components/forms/SiteAnalyticsForm'
import Tooltip from '@/components/Tooltip'
import Btn from '@/components/Btn'
import Tabs from '@/components/Tabs'
import Tab from '@/components/Tab'

export default {
  name: 'edit-site-analytics',

  components: {
    SiteAnalyticsForm,
    Tooltip,
    Btn,
    Tabs,
    Tab
  },

  mixins: [page, notification],

  props: {
    siteId: String,
    companyId: String
  },

  data() {
    return {
      site: {},
      errors: {},
      hasGoogleAccount: false
    }
  },

  computed: {
    title() {
      return `Editing ${this.site.name} Analytics`
    },

    updatedNotification() {
      return {
        type: 'success',
        content: `Analytics settings updated!`
      }
    }
  },

  methods: {
    submitSite() {
      updateCompanySiteData(this.companyId, this.siteId, this.site)
        .then(({data}) => {
          this.$emit('updatePage')
          this.triggerNotification('success', 'Google Analytics', 'updated')
        })
        .catch(({response}) => {
          this.errors = response.errors
        })
    },

    activateGoogleControls() {
      this.hasGoogleAccount = true

      window.setTimeout(() => {
        this.$refs.analyticTabs.setHeight(1)
      }, 250)
    },

    getData() {
      readCompanySiteData(this.companyId, this.siteId).then(({data}) => {
        this.site = data
      })
    }
  },

  mounted() {
    this.getData()
  }
}
</script>
